module.exports = __webpack_public_path__ + "img/page.1ba02be7.png";